/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class DealerOpenOrderListApi {
    static getInstance() {
        if (!this.instance) this.instance = new DealerOpenOrderListApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // // 获取列表
    // async getList (param){
    //     let url = `/api/report/open/order`
    //     let result = await this.getData(url,param,'GET')
    //     return result
    // }

    // 获取列表（分页）
    async getList (param, page_num, page_size){
        let url = `/api/report/open/order/view/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 导出
    // async exportData (param){
    //     let url = `/api/report/open/order/export`
    //     let result = await this.getData(url,param,'GET')
    //     return result
    // } 

    async exportData (param){
        let url = `/api/report/open/order/view/export`
        let result = await this.getData(url,param,'POST')
        return result
    } 
    
    // 导出全部数据
    // async exportAllData (param){
    //     let url = `/api/report/open/order/view/export`
    //     let result = await this.getData(url,param,'POST')
    //     return result
    // } 
}

export {
    DealerOpenOrderListApi
}